import validate from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45global from "/home/binaffan.com/nuxt-frontend/middleware/authentication.global.js";
import manifest_45route_45rule from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/home/binaffan.com/nuxt-frontend/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}